import { render, staticRenderFns } from "./why-gb-whatsapp-update-fails.vue?vue&type=template&id=e64fbf1c&scoped=true"
import script from "./why-gb-whatsapp-update-fails.vue?vue&type=script&lang=js"
export * from "./why-gb-whatsapp-update-fails.vue?vue&type=script&lang=js"
import style0 from "./why-gb-whatsapp-update-fails.vue?vue&type=style&index=0&id=e64fbf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64fbf1c",
  null
  
)

export default component.exports